import { render, staticRenderFns } from "./SummaryCheckItem.vue?vue&type=template&id=36f679e3"
import script from "./SummaryCheckItem.vue?vue&type=script&lang=js"
export * from "./SummaryCheckItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports